export default __webpack_public_path__ + "static/HeroVideoforMob-9fe829c99eaa59ac9fdce10a057d4833.mp4";